import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfo } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfo';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSender } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessageSender';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageStatus } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessageStatus';

/**
 * 마지막 메시지
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemLastMessage = {
  basicInfo?: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfo;
  /** 발신자 정보 */
  sender?: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSender;
  /** 메시지 상태 정보 */
  status?: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageStatus;
};
